import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const AddHighLightLayer = () => {
  const [formValues, setFormValues] = useState({
    name: "",
    type: "",
    position: "Employee",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [touched, setTouched] = useState(false);
  const navigate = useNavigate();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [imagePreview, setImagePreview] = useState(
    "assets/images/user-grid/user-grid-img13.png"
  );

  const readURL = (input) => {
    if (input.target.files && input.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(input.target.files[0]);
    }
  };

  // snackbar
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if(loading) return; // Prevent multiple submissions
    
    
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }

      const formData = new FormData();
      formData.append("name", formValues.name);
      formData.append("type", formValues.type);
      formData.append("position", formValues.position);
      // formData.append("link", formValues.link);

      const imageInput = document.querySelector("#student-image");
      if (imageInput && imageInput.files[0]) {
        formData.append("profile_image", imageInput.files[0]);
      }

      // console.log( "REACT_APP_INSTITUTION_BASEURL:: ", process.env.REACT_APP_INSTITUTION_BASEURL );
      const response = await axios.post(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/add-team`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
          "Content-Type": "multipart/form-data",
        }
      );
      if (response.status === 201) {
        setSnackbarMessage("Created successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/team-list");
        }, 2000);
      }
    } catch (err) {
      setLoading(false);
      // Check for 400 status error
      if (err.response && err.response.status === 400) {
        setSnackbarMessage("Please add an Image.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      } else {
        setSnackbarMessage("Failed to create. Please try again.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    } 
  };

  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
        <div className="card h-100">
          <div className="card-body p-24">
            <form onSubmit={handleFormSubmit}>
              <div className="mb-20">
                <label
                  htmlFor="title"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Profile Image
                  <span className="text-danger-600">*</span>
                </label>
                <div className="avatar-upload">
                  <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
                    {/* File input hidden using CSS */}
                    <input
                      type="file"
                      id="student-image"
                      accept="image/*"
                      className="d-none" // This hides the file input
                      onChange={readURL}
                    />
                    <label
                      htmlFor="student-image" // Bind label to file input
                      className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-primary-50 text-primary-600 border border-primary-600 bg-hover-primary-100 text-lg rounded-circle"
                    >
                      <Icon icon="solar:camera-outline" className="icon" />
                    </label>
                  </div>
                  <div className="avatar-preview">
                    <div
                      id="imagePreview"
                      style={{
                        backgroundImage: `url(${imagePreview})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="mb-20">
                <label
                  htmlFor="name"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Name
                  <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  required
                  className="form-control radius-8"
                  id="name"
                  placeholder="Enter Name"
                  value={formValues.name}
                  onChange={(e) => {
                    
                    const value = e.target.value;

                    if (value === "" || value.trim() !== "") {
                      setFormValues({
                        ...formValues,
                        name: value,
                      });
                    }
                  }}
                  onBlur={() => setTouched(true)} // Mark as touched when losing focus
                />
                {/* {touched && !formValues.title && (
                  <small className="text-danger-600">
                    Title Name is required
                  </small>
                )} */}
              </div>
              <div className="mb-20">
                <label
                  htmlFor="type"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Position
                  <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  required
                  className="form-control radius-8"
                  id="type"
                  placeholder="Enter Position"
                  value={formValues.type}
                  onChange={(e) => {
                    
                    const value = e.target.value;

                    if (value === "" || value.trim() !== "") {
                      setFormValues({
                        ...formValues,
                        type: value,
                      });
                    }
                  }}
                  onBlur={() => setTouched(true)} // Mark as touched when losing focus
                />
                {/* {touched && !formValues.description && (
                  <small className="text-danger-600">
                    Title Name is required
                  </small>
                )} */}
              </div>
              {/* <div className="mb-20">
                <label
                  htmlFor="link"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Link
                  <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  required
                  className="form-control radius-8"
                  id="link"
                  placeholder="Enter Description"
                  value={formValues.link}
                  onChange={(e) => {
                    
                    const value = e.target.value;

                    if (value === "" || value.trim() !== "") {
                      setFormValues({
                        ...formValues,
                        link: value,
                      });
                    }
                  }}
                  onBlur={() => setTouched(true)} // Mark as touched when losing focus
                />
                 {touched && !formValues.description && (
                  <small className="text-danger-600">
                    Title Name is required
                  </small>
                )} 
              </div> */}

              <div className="d-flex align-items-center justify-content-center gap-3">
                <button
                  type="button"
                  className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                  onClick={() => navigate("/team-list")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                  // onClick={handleFormSubmit}
                >
                  {loading && (
                    <div
                      className="loader-container"
                      style={styles.loaderContainer}
                    >
                      <CircularProgress />
                    </div>
                  )}
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          // variant="filled"
          // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default AddHighLightLayer;
